import loadable from '@loadable/component';

// 懒加载组件
const InDetailQuery = loadable(() => import('./inDetailQuery/InDetailQuery'));
const OutDetailQuery = loadable(() => import('./outDetailQuery/OutDetailQuery'));
const InventoryDetailQuery = loadable(() => import('./inventoryDetailQuery/InventoryDetailQuery'));
const ConcentrateProjectManagement = loadable(() => import('./concentrateProjectManagement/ConcentrateProjectManagement'));
const ConcentrateProjectModify = loadable(() => import('./concentrateProjectManagement/concentrateManagement/ConcentrateManagement'));
const ConcentrateUserDetailModify = loadable(() => import('./concentrateProjectManagement/concentrateManagement/concentrateConsumeDetailModify/ConcentrateConsumeDetailModify'));
const ConcentrateDetailFromProjectModify = loadable(() => import('./concentrateProjectManagement/concentrateManagement/concentrateDetailModify/ConcentrateDetailModify'));
const InventoryDayQuery = loadable(() => import('./inventoryDayQuery/InventoryDayQuery'));
const ItemInventoryDayQuery = loadable(() => import('./itemInventoryDayQuery/ItemInventoryDayQuery'));

export const subRoutes = [
  {
    // M255001 供应商：入库明细查询
    path: '/InDetailQuery',
    component: InDetailQuery
  },
  {
    // M255002 供应商：消耗明细查询
    path: '/OutDetailQuery',
    component: OutDetailQuery
  },
  {
    // M255003 供应商：库存余额明细查询
    path: '/InventoryDetailQuery',
    component: InventoryDetailQuery
  },
  {
    // M255004 供应商：日库存查询
    path: '/InventoryDayQuery',
    component: InventoryDayQuery
  },
  {
    // M255005 供应商：进销存查询
    path: '/ItemInventoryDayQuery',
    component: ItemInventoryDayQuery
  },
  {
    // M251027 供应商：集采项目任务量管理
    path: '/ConcentrateProjectManagement',
    component: ConcentrateProjectManagement
  },
  {
    // M251027 供应商：集采项目任务量管理 明细编辑
    path: '/ConcentrateProjectModify',
    component: ConcentrateProjectModify
  },
  {
    // M251027 供应商：集采项目任务量管理 耗材使用明细
    path: '/ConcentrateUserDetailModify',
    component: ConcentrateUserDetailModify
  },
  {
    // M251027 供应商：集采项目任务量管理 耗材明细
    path: '/ConcentrateDetailFromProjectModify',
    component: ConcentrateDetailFromProjectModify
  }
];
